import { setUploadDocumentsValue, transitionUploadDocuments } from "../../../actions/sizotsaFuneralClaim/uploadDocuments";
import { calculateAge } from "../../../functions/easiplusFuneralPlan/Util";
import { FIELD_STATUS } from "../../../reducers/status";
import { getClaimentType } from "../../../selectors/sizotsaFuneralClaim/claimentDetails";
import { getDeceasedDetailsForm } from "../../../selectors/sizotsaFuneralClaim/deceasedDetails";
import { getUploadDocumentValidations } from "../../../selectors/sizotsaFuneralClaim/uploadDocuments";

const isUploadDocumentsValid = store => {
    const state = store.getState();
    const isValid = (field) => {
        return field && field.status === FIELD_STATUS.VALID;
    };
    const uploadDocumentsValidations=getUploadDocumentValidations(state)
    const claimentType=getClaimentType(state)
    const {cause,dateOfBirth}=getDeceasedDetailsForm(state)
    const {policeReportFile,birthCertificateFile,adoptionCertificateFile,...remainigDocs}=uploadDocumentsValidations[claimentType?.displayValue]
    const formFields={
        ...(['02', '03'].includes(cause?.value) ? {policeReportFile} : []),
        ...(dateOfBirth?.value !== null
            ? calculateAge(dateOfBirth?.value) < 18
                ? {birthCertificateFile, adoptionCertificateFile}
                : []
            : []),
        ...remainigDocs,
    }
    const uploadDocumentsFields=[...Object.values(formFields)]
    const uploadDocumentsValid = uploadDocumentsFields.every(isValid)
    return uploadDocumentsValid 
}
export const uploadDocumentsRules = (store, next, action) => {
    const result = next(action);

    // Personal Information
    const isValid = isUploadDocumentsValid(store);
    store.dispatch(isValid ? transitionUploadDocuments.formValid() : transitionUploadDocuments.formInvalid());
  
    return result;
};

export const performUploadDocumentsValidation=(store)=>{
    // const createDispatchHandler = (fieldType, value, displayValue) => {
    //     store.dispatch(setUploadDocumentsValue({ fileName, fileContaint, file, fieldType }));
    // };
    const state=store.getState()
    const uploadDocumentsValidations=getUploadDocumentValidations(state)
    const claimentType=getClaimentType(state)
    const {cause,dateOfBirth}=getDeceasedDetailsForm(state)
    const { policeReportFile, birthCertificateFile, adoptionCertificateFile, ...remainigDocs } =uploadDocumentsValidations[claimentType.displayValue]
    
    const formFields={
        ...(['02', '03'].includes(cause?.value) ? {policeReportFile} : []),
        ...(dateOfBirth?.value !== null
            ? calculateAge(dateOfBirth?.value) < 18
                ? {birthCertificateFile, adoptionCertificateFile}
                : []
            : []),
        ...remainigDocs,
    }

    Object.keys(formFields).map((property) => {
        const { fileName, fileContaint,file } = formFields[property];
        store.dispatch(setUploadDocumentsValue({ fileName, fileContaint, file, fieldType:property }));

    });
    

}

